import actions from './ProvidersActions';
import mutations from './ProvidersMutations';
import state from './ProvidersState';

// Namespaced Vuex module which contains its
// own state, actions, getters, mutations.
export default {
  state,
  actions,
  mutations,
  namespaced: true
};
